import {
  COLOUR_CASH_LOAN_1,
  COLOUR_CASH_LOAN_2,
  COLOUR_CASH_LOAN_3,
  COLOUR_RETAIL_LOAN_1,
  COLOUR_RETAIL_LOAN_2,
  COLOUR_RETAIL_LOAN_3,
  COLOUR_CONSOLIDATION_LOAN_1,
  COLOUR_CONSOLIDATION_LOAN_2,
  COLOUR_CONSOLIDATION_LOAN_3
} from '../../constants'


export const getColourConstant = (constantName) => (
  {
    // product colours
    'cash_loan-1': COLOUR_CASH_LOAN_1,
    'cash_loan-2': COLOUR_CASH_LOAN_2,
    'cash_loan-3': COLOUR_CASH_LOAN_3,
    'retail_loan-1': COLOUR_RETAIL_LOAN_1,
    'retail_loan-2': COLOUR_RETAIL_LOAN_2,
    'retail_loan-3': COLOUR_RETAIL_LOAN_3,
    'consolidation_loan-1': COLOUR_CONSOLIDATION_LOAN_1,
    'consolidation_loan-2': COLOUR_CONSOLIDATION_LOAN_2,
    'consolidation_loan-3': COLOUR_CONSOLIDATION_LOAN_3
  }[constantName]
)



// WEBPACK FOOTER //
// ./src/utils/colour/index.js